import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {config_segments_template} from "../components/templates/configSegmentsList_template";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class config_segments extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: config_segments_template;


    protected getModuleName(): string {

      return "config_segments";
    }

    buildContent(): Array<Element> {

        this.elementsList = new config_segments_template("list", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Segments");

        return [this.elementsList.build()];
    }

    public fillPage() {

      this.filterList();
    }

    protected paginationOnPageClick(){

      this.filterList();
    }

    protected segmentsListReorder(){

      this.filterList();
    }

    protected filterSimpleOnChange(){

      this.viewModel.list.pagination.pageNumber(1);
      this.filterList();
    }

    protected filterSimpleCancel(){

      if( this.XHRHdl ){
          this.XHRHdl.cancelAndReset();
      }
    }

    protected filterList() {

      if (this.XHRHdl) {
          this.XHRHdl.cancelAndReset();
      }

      // LOADING : starts
      this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

      let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand +'/segments/get';
      let usrReq_params: Array<Array<string>> = [];
      usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );
      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
      this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
      this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

      return function(){
          obj.manageResponse(req, obj, function(){

              let responseParsed = JSON.parse(req.request.response);
              obj.updateList(responseParsed);
          });
          obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
      }
    }

    protected updateList(responseParsed: any){

      let segmentsToSet = responseParsed.data;

      this.elementsList.setSegments(segmentsToSet);

      let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
      this.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

      this.viewModel.list.pagination.itemCount(responseParsed.totalCount);
    }

    protected saveSegment(segmentToSave) {
      let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/segments/save';
      let usrReq_params: Array<Array<string>> = [];
      usrReq_params.push(["data", ko.toJSON(segmentToSave)]);
      
      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
      this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;  
      this.XHRHdl.onReadyStateFunction = this.onSaveSegmentRequestReturn;
      this.XHRHdl.execute();
    }

    protected onSaveSegmentRequestReturn(req, obj){

      return function(){
          obj.manageResponse(req, obj, function(){
              obj.filterList();
          });
      }
    }

    public getIdBrand() {
      return Number(this.getVnAppZone().app.params.idBrand);
    }
}



// WEBPACK FOOTER //
// ./js/modules/config_segments.ts